<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.go(-1)" density="compact" variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h5 mt-3 mb-4">Changement de parcours</div>
            <InscriptionItem v-if="bookingStore.has_initial_commande_inscription_loaded"
              :item="bookingStore.inscriptions[0]"
              :initial_commande_inscription="bookingStore.initial_commande_inscription">
            </InscriptionItem>

            <v-divider></v-divider>
            <v-row v-if="bookingStore.show_reglement_checkboxes">
              <v-col>
                <v-checkbox v-if="bookingStore.has_remaining_credit" class="checkbox_connaissance mb-1"
                  color="primary-dark" hide-details v-model="accept_credit">
                  <template v-slot:label>
                    <p>J'accepte que tout crédit non utilisé lors de ce changement de parcours sera perdu et non
                      remboursé.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_reglement">
                  <template v-slot:label v-if="!mainStore.billetterie_mode">
                    <p>J'ai pris connaissance du <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">règlement</a><span v-else>règlement</span>, en accepte
                      les termes sans réserve.</p>
                  </template>
                  <template v-slot:label v-else>
                    <p>J'ai pris connaissance des <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">CGV</a><span v-else>CGV</span>, en accepte les termes
                      sans réserve.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_donnees">
                  <template v-slot:label>
                    <p>J'ai pris connaissance des <a href="https://sportips.fr/vie-privee.php"
                        target="_blank">informations relatives au traitement de mes données</a>, dont j'autorise le
                      recueil par Sportips.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_newsletter">
                  <template v-slot:label>
                    <p>J'accepte de recevoir les news Courses de la part de Sportips.</p>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <div class="d-flex justify-center mb-1 mx-1" v-if="bookingStore.show_reglement_checkboxes">
              <v-btn v-if="bookingStore.has_some_inscriptions_opened" color="primary-dark"
                class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                <v-tooltip activator="parent" location="top">Vous devez compléter l'inscription ouverte afin de
                  finaliser votre inscription</v-tooltip>
              </v-btn>
              <v-btn
                v-else-if="!accept_donnees || !accept_reglement || (bookingStore.has_remaining_credit && !accept_credit)"
                color="primary-dark" class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                <v-tooltip activator="parent" location="top">Vous devez accepter le règlement de l'épreuve et autoriser
                  Sportips à traiter vos données</v-tooltip>
              </v-btn>

              <router-link class="sm-fullwidth" v-else :to="{ name: 'ChangerParcoursCart' }">
                <v-btn color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn" variant="tonal"
                  size="small"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription </v-btn>
              </router-link>
            </div>
          </div>
        </v-col>
        <v-col lg="3" cols="12">
          <ShoppingCart v-if="bookingStore" ref="shopping_cart">
          </ShoppingCart>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import InscriptionItem from "@/components/FicheCoureur/ChangementParcours/InscriptionItem.vue";
import ShoppingCart from "@/components/App/Shopping_Cart/Shopping_Cart.vue";
export default {
  components: {
    InscriptionItem,
    ShoppingCart,
  },
  data() {
    return {
      accept_reglement: false,
      accept_donnees: false,
      accept_newsletter: true,
      accept_credit: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  methods: {
  },
  async created() {
    if (!this.mainStore.authUser.isLogged) {
      this.$router.push({ name: "FicheCoureur" });
    }
    if (!this.$route.params.id_commande_inscription) {
      this.$router.push({ name: "FicheCoureur" });
    }
    this.mainStore.bookingSystem.init();
    await this.mainStore.champs_formulaire.fetch();
    await this.bookingStore.init_initial_commande_inscription(this.$route.params.id_commande_inscription);
  },
};
</script>

<style lang="scss" scoped></style>